import { SimpleForm, Create, FileInput, FileField, TextInput, CreateProps, required } from "react-admin";

const validateRequired = [required('مقدار را وارد کنید')];

export const UserIdentificationCreate = (props: CreateProps): React.ReactElement => {
    return (
        <Create {...props}>
            <SimpleForm style={{ direction: 'rtl' }}>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', gap: '1rem'}}>
                    <FileInput validate={validateRequired} isRequired className="partner-upload-file" fullWidth accept=".csv" labelSingle="برای آپلود فایل csv کلیک کنید" source="attachment">
                        <FileField source="src" title="title" />
                    </FileInput>                
                </div>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', gap: '1rem'}}>
                    <TextInput type="date" validate={validateRequired} isRequired style={{width: '100%'}} source="expirationDate" label="تاریخ انقضا" />                                       
                </div>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', gap: '1rem'}}>
                    <TextInput style={{width: '100%'}} source="utmCampaign" label="کمپین" />
                    <TextInput style={{width: '100%'}} source="utmMedium" label="مدیوم" />
                    <TextInput style={{width: '100%'}} source="utmSource" label="سورس" />
                </div>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', gap: '1rem'}}>
                    <TextInput validate={validateRequired} isRequired style={{width: '100%'}} source="targetPageAddress" label="لینک صفحه هدف" />
                </div>
            </SimpleForm>
        </Create>
    )
}